<template>

      <!-- [ Invite User form Registration ] start -->
      <el-row v-if="showFormRegistration" :gutter="20" type="flex" justify="center">
        <el-col :span="24">
          <el-form :model="formRegistration" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">

            <el-form-item prop="email">
              <el-input v-model="formRegistration.email" placeholder="Email" disabled></el-input>
            </el-form-item>

            <!-- <el-form-item prop="hash">
              <el-input v-model="formRegistration.hash" placeholder="Code"></el-input>
            </el-form-item> -->

            <el-form-item prop="firstname">
              <el-input v-model="formRegistration.firstname" placeholder="First name"></el-input>
            </el-form-item>

            <el-form-item prop="lastname">
              <el-input v-model="formRegistration.lastname" placeholder="Last name"></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input type="password" v-model="formRegistration.password" placeholder="Password"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="width-100" @click="submitFormRegistration('form')">Registration</el-button>
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <!-- [ Invite User form Registration ] end -->

</template>

<script>
import axios from 'axios'
  export default {
    props: {
      showFormRegistration: {
        type: Boolean
      },
    },
    data() {
      return {

        formRegistration: {
          companyId: '',
          email: '',
          hash: '',
          password: '',
          firstname: '',
          lastname: ''
        },
        rules: {
          email: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
          hash: [
            { required: true, message: 'Please input Code', trigger: 'blur' },
            { min: 1, message: 'Length should be 1', trigger: 'blur' }
          ],
          firstname: [
            { required: true, message: 'Please input Activity First Name', trigger: 'blur' },
            { min: 1, message: 'Length should be 1', trigger: 'blur' }
          ],
          lastname: [
            { required: true, message: 'Please input Activity Last Name', trigger: 'blur' },
            { min: 1, message: 'Length should be 1', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Please input Password', trigger: 'blur' },
            { min: 8, message: 'Length should be 8', trigger: 'blur' }
          ],
        },

      }
    },
    created() {
      if (this.$route.query.companyId) this.formRegistration.companyId = this.$route.query.companyId
      if (this.$route.query.email) this.formRegistration.email = this.$route.query.email
      if (this.$route.query.hash) this.formRegistration.hash = this.$route.query.hash
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    methods: {
      submitFormRegistration(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios
              .post(`/api/v1/companyUsers/confirmUnregistedUserInvite?companyId=${this.formRegistration.companyId}`, {
                email: this.formRegistration.email,
                hash: this.formRegistration.hash,
                password: this.formRegistration.password,
                firstname: this.formRegistration.firstname,
                lastname: this.formRegistration.lastname
              })
               .then(response => {
                 // Handle success.
                //  localStorage.setItem('token', response.data.token)
                 sessionStorage.setItem('token', response.data.token)
                 this.$store.dispatch('loadUser').then(response => {
                   console.log(response)
                   if(response){
                     if(response.companyList){
                       let compare = false;
                       response.companyList.forEach(val =>{
                         if(val.id === response.lastCompanyId){
                           compare = true;
                           // localStorage.setItem('companyName', val.name)
                           localStorage.setItem('companyId', val.id)
                         }
                       })
                       if(compare){
                         this.$store.dispatch('companyChange', response.lastCompanyId)
                         this.$store.dispatch('getCompanyLayout', response.lastCompanyId).then(re => {
                           console.log('companyUserId', re)
                           let data = {
                             companyId: response.lastCompanyId,
                             companyUserId: re.companyUserId
                           }
                           this.$socket.emit('companyChanged', data)
                         })
                         this.$store.dispatch('getMenuStatistics', response.lastCompanyId).then(resp =>{
                           if(resp.lastProjectId !== null){
                             localStorage.setItem('selectedProjectId', resp.lastProjectId)
                             this.$router.push(`/projects?companyId=${response.lastCompanyId}&projectId=${resp.lastProjectId}`)
                           }else{
                             this.$router.push(`/projects?companyId=${response.lastCompanyId}`)
                           }
                         })
                       }else if (response.lastCompanyId === null) {
                         this.$router.push(`/settings`)
                       }else{
                         this.$store.dispatch('getCompanyLayout', response.companyList[0].id).then(re => {
                           console.log('companyUserId', re)
                           let data = {
                             companyId: response.companyList[0].id,
                             companyUserId: re.companyUserId
                           }
                           this.$socket.emit('companyChanged', data)
                         })
                         this.$store.dispatch('companyChange', response.companyList[0].id)
                         this.$router.push(`/projects?companyId=${response.companyList[0].id}`)
                       }
                     }
                   }
                 }, error => {
                   console.error(error)
                 })
                 loader.hide()
                // Handle success.
                // console.log('Your user received an email');
                // console.log('---', response.data);
                // this.notification("Success", "Successfully", "success")
                // localStorage.setItem('token', response.data.token);
                // this.$store.dispatch('loadUser')
                // setTimeout(() => {
                // // this.$router.push('/');
                // this.$router.push(`/projects?companyId=${this.user.companyList[0].id}`);
                // }, 1000)
                // loader.hide()
              })
              // .then(response => {
              //   // Handle success.
              //   console.log('Your user received an email');
              //   console.log('---', response.data);
              //   this.notification("Success", "Successfully", "success")
              //
              //   localStorage.setItem('token', response.data.token);
              //   this.$router.push('/');
              //   loader.hide()
              // })
              .catch(error => {
                // Handle error.
                console.log('An error occurred:', error);
                if (error.response.data.message === "invite_not_exists") {
                  this.notification("Notification", "invite not exists", "info");
                }
                console.log('An error occurred:', error.response.data.message);
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
.inviteUser {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100wh;
	height: 100vh;
  text-align: center;
  padding: 0 20px;

  background: linear-gradient(0deg,#29b996,#3498db);
	background-size: 400% 400%;
	animation: backgroundGradient 10s ease infinite;

  text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-tap-highlight-color: rgba(0,0,0,0);

  @keyframes backgroundGradient {
    0% {
      background-position: 0 0;
    }

    50% {
      background-position: 0 100%;
    }

    100% {
      background-position: 0 0;
    }
  }

  .wrapper {
    box-sizing: border-box;
    max-width: 350px;
    padding: 40px 35px;
    background: #ffffff;
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
  }
  .text-align-left {
    text-align: left;
  }
  .width-100 {
    width: 100%;
  }
  .mb {
  margin-bottom: 20px;
  }
}

.footer__link {
  line-height: 1.6;
  color: #909399;
}

.row-padding {
  padding: 10px 0;
}
</style>
